<template>
	<v-card class="pt-3">
		<div class="px-3 text-center" v-show="!loading">
			<div>
				<v-avatar size="60">
					<img src="/avatar-user.jpg" alt="">
				</v-avatar>
			</div>
			<h5 class="pt-1 text-h5 ">
				{{ localData ? localData.fullName : '' }}
			</h5>
			<h6 class="pb-2 text-h6 grey--text">
				نام کاربری: <span>&lrm;{{ localData ? localData.userName : '' }}</span>
			</h6>
			<div class="py-1">
				<v-btn dark small color="blue" title="ویرایش اطلاعات" @click="edit">
					<v-icon dark>
						mdi-square-edit-outline
					</v-icon>
					ویرایش اطلاعات
				</v-btn>
			</div>
			<div class="py-1" v-if="showManageLoans">
				<v-btn dark small color="blue" title="پرونده مشتری" @click="dialogLoansManager = true">
					<v-icon dark>
						mdi-cash-check
					</v-icon>
					پرونـــده مشــتری
				</v-btn>
			</div>
		</div>
		<div class="mt-5 pa-2" style="border-top: 1px dashed rgb(191 191 191);" v-show="!loading">
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">کد ملی:</div>
				<div class="text-subtitle-1 text-left secondary--text">{{ localData ? localData.nationalCode : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">موبایل:</div>
				<div class="text-subtitle-1 text-left secondary--text">{{ localData ? localData.mobile : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">نام پدر:</div>
				<div class=" text-subtitle-1 text-left secondary--text">{{ localData ? localData.fatherName : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">تعداد وام:</div>
				<div class=" text-subtitle-1 text-left secondary--text">{{ localData ? localData.loanCount : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">مجموع وام ها:</div>
				<div class=" text-subtitle-1 text-left secondary--text">{{ localData ?
					String(localData.totalLoans).toPriceFormat() : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">مانده اقساط:</div>
				<div class=" text-subtitle-1 text-left secondary--text">{{ localData ?
					String(localData.totalRemain).toPriceFormat() : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">تاریخ عضویت:</div>
				<div class=" text-subtitle-1 text-left secondary--text" style="direction: ltr; line-height: 15px;padding-top: 5px;">{{ localData && localData.regDate2_Persian &&
					localData.regDate2_Persian.year !== '0' ? `${localData.regDate2_Persian.date}
					${localData.regDate2_Persian.time}` : '-' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">آخرین ورود:</div>
				<div class=" text-subtitle-1 text-left secondary--text">&lrm;{{ localData && localData.lastLoginDate_Persian &&
					localData.lastLoginDate_Persian.year != '0' ? localData.lastLoginDate_Persian.date : '-' }} {{ localData &&
						localData.lastLoginDate_Persian && localData.lastLoginDate_Persian.year != '0' ?
						localData.lastLoginDate_Persian.time : '' }}</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">اعتبار کیف پول:</div>
				<div class=" text-subtitle-1 text-left secondary--text">
					{{ localData ? String(localData.credit).toPriceFormat() : '' }}
					<div style="margin-top: -10px;">
						<a @click="creditChargeTransactions" style="font-size:11px" class="secondary--text" v-if="localData && localData.credit">
							(مشاهده تراکنش ها)
						</a>
					</div>
				</div>
			</div>
			<div class="d-flex justify-space-between my-2">
				<div class="text-subtitle-1 text-right">وضعیت خوش حسابی:</div>
				<div class=" text-subtitle-1 text-left secondary--text">
					<ReliabilityManager :member="localData" style="cursor:pointer" />
				</div>
			</div>
		</div>
		<v-skeleton-loader v-bind="skeletonAttrs" type="list-item-avatar-three-line, actions, table-heading, table-heading, table-heading" v-if="loading"></v-skeleton-loader>
		<v-dialog v-model="dialogMember" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات مشتری</span>
					<v-spacer />
					<v-btn @click="dialogMember = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-member :data="localData" v-if="dialogMember" @callbck="callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: localData }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOnlineGatewayPayments" scrollable max-width="1100px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تراکنش های پرداخت آنلاین</span></div>
					<v-spacer />
					<v-btn @click="dialogOnlineGatewayPayments = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<online-gateway-payments ref="onlineGatewayPayments" v-if="dialogOnlineGatewayPayments" :data="{ memberId: this.data.id }" :autoLoad="true" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import ReliabilityManager from '@/components/ReliabilityManager'

	export default {
		name: 'MemberProfileDetail',
		props: {
			data: { type: Object },
			loading: { type: Boolean },
			showManageLoans: { type: Boolean, default: false },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'manage-loan': () => import('@/views/admin/ManageLoan.vue'),
			'modify-member': () => import('@/views/admin/ModifyMember'),
			'online-gateway-payments': () => import('@/views/admin/Report/OnlineGatewayPayments.vue'),
			ReliabilityManager: ReliabilityManager
		},
		data() {
			return {
				dialogOnlineGatewayPayments: false,
				skeletonAttrs: {
					class: 'mb-6',
					boilerplate: false,
					elevation: 2,
				},
				dialogLoansManager: false,
				dialogMember: false,
				localData: null,
				errorMessages: '',
			}
		},
		watch: {
			data: {
				deep: true,
				handler(val) {
					this.localData = Object.assign({}, val)
				}
			}
		},
		mounted() {

		},
		methods: {
			edit() {
				this.dialogMember = true
			},
			callbck(result) {
				this.dialogMember = false
				if (result) {
					this.$emit('reload')
				}
			},
			creditChargeTransactions() {
				this.dialogOnlineGatewayPayments = true
			}
		},
	}
</script>
<style></style>
